import {store} from '../../../Reports/ReportsList'

export default function rowClassName(record, index) {
  const state = store.getState()

  const highlight = state[record.id] ? 'row-highlight' : ''
  return highlight // string
}
